export const changePasswordErrorMessages: Record<string, string> = {
    NotAuthorizedException: 'Hasło jest nieprawidłowe. Spróbuj jeszcze raz.',
    LimitExceededException: 'Zbyt wiele prób zmiany hasła. Zaczekaj 5 minut i spróbuj ponownie.',
};
